import { AxiosRequestHeaders } from 'axios'
import APIService from './APIService'


export default class APIServiceImpl implements APIService {
    private serviceUrl: string

    constructor(serviceUrl: string) {
        this.serviceUrl = serviceUrl
    }

    // public methods

    public getSeason(): string {
        return window.season || ''
    }

    public getPackCode(): string {
        return window.packCode || ''
    }

    public getLocale(): string {
        return window.locale.replaceAll("_", "-") || ''
    }

    public getServiceUrl(): string {
        return this.serviceUrl
    }
    public setServiceUrl(newUrl: string) {
        this.serviceUrl = newUrl
    }

    public getDefaultHeaders(): AxiosRequestHeaders {
        const locale = this.getLocale()
        return {
            'Accept-Language': locale,
            'Content-Type': 'application/json',
        }
    }

}